import { useMemo } from 'react';
import { useAppSelector } from './useAppSelector';
import { buildRequestForDeepestGeoLevel } from '../util/buildRequestForDeepestGeoLevel';
import { useResolvedTableState } from './useResolvedTableState';
import useDateAndTime from './useDateAndTime';

export const useStatsPayload = () => {
  const { startDate, endDate } = useDateAndTime();
  const filters = useAppSelector((state) => state.globalFilters);
  const selectedDevices = filters.PaymentSource || [];
  const selectedPaymentTypes = filters.PaymentType || [];
  const selectedCurrency = useAppSelector((state) => state.configSlice.selectedCurrency);
  const { resolvedGroupBy } = useResolvedTableState(selectedDevices, selectedPaymentTypes);

  const payload = useMemo(
    () => ({
      Date: {
        StartDate: startDate,
        EndDate: endDate,
      },
      groupBy: resolvedGroupBy,
      ...buildRequestForDeepestGeoLevel(filters),
      CCY: null,
      OrderBy: null,
      games: filters.Games?.length ? filters.Games.map((g) => Number(g.ID)) : null,
      paymentSources: filters.PaymentSource?.length ? filters.PaymentSource.map((p) => p.ID) : null,
      paymentType: selectedPaymentTypes.length ? selectedPaymentTypes.map((type) => type.ID) : null,
      statisticBy: filters.GameActivity?.id ?? null,
      hasTestData: filters.TestData?.id ?? null,
    }),
    // eslint-disable-next-line
    [startDate, endDate, filters, resolvedGroupBy, selectedCurrency],
  );
  return payload;
};
